// src/config.ts
import {
  Al,
  At,
  Au,
  Bg,
  Br,
  Ca,
  Ch,
  Cn,
  Cs,
  De,
  Dk,
  Es,
  Fi,
  Fr,
  Gb,
  Gr,
  Hu,
  Ie,
  In,
  Int,
  It,
  Md,
  Nl,
  No,
  Nz,
  Pl,
  Pt,
  Ro,
  Ru,
  Se,
  Tr,
  Us
} from "@airhelp/flags";
var FLAG_ICON_MAP = {
  Al,
  Bg,
  Cs,
  Da: Dk,
  De,
  DeAt: At,
  DeCh: Ch,
  El: Gr,
  EnAu: Au,
  EnCa: Ca,
  EnGb: Gb,
  EnIe: Ie,
  EnIn: In,
  EnInt: Int,
  EnNz: Nz,
  EnUs: Us,
  Es,
  Fi,
  Fr,
  FrCa: Ca,
  Hu,
  It,
  Nb: No,
  Nl,
  Pl,
  Pt,
  PtBr: Br,
  Ro,
  RoMd: Md,
  Ru,
  Sv: Se,
  ZhCn: Cn,
  Tr
};

export {
  FLAG_ICON_MAP
};
